import * as go from 'gojs';
import { DRAG_CREATING_LINK_TOOL_NAME } from './config';
import { DragCreatingLinkTool } from './drag-creating-link-tool';

const setupDragCreatingLinkTool = (diagram: go.Diagram) =>
  diagram.toolManager.mouseDownTools.insertAt(2, new DragCreatingLinkTool());

const runDragCreatingLinkTool = (
  diagram: go.Diagram,
  linkProperties: go.ObjectData,
  cursor: string,
  allowedClickClass: string,
  linkTemplate: go.Link,
  customIsValidFrom?: (tool: go.LinkingTool) => (fromNode: go.Node, fromPort: go.GraphObject) => boolean,
  customIsValidTo?: (tool: go.LinkingTool) => (toNode: go.Node, toPort: go.GraphObject) => boolean,
) => {
  const tool = diagram.toolManager.findTool(DRAG_CREATING_LINK_TOOL_NAME) as DragCreatingLinkTool;
  tool.cursor = cursor;
  tool.archetypeLinkData = linkProperties;
  tool.allowedClickClass = allowedClickClass;
  tool.temporaryLink = linkTemplate;
  tool.isValidFrom = customIsValidFrom ? customIsValidFrom(tool) : tool.isValidFrom;
  tool.isValidTo = customIsValidTo ? customIsValidTo(tool) : tool.isValidTo;
  if (tool) {
    tool.startManually();
  }
};

export const dragCreatingLinkToolAPI = {
  setup: setupDragCreatingLinkTool,
  run: runDragCreatingLinkTool,
};
